import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  authUserFormInitialValues,
} from 'components/organisms/forms/user/AuthUserForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useTranslation } from 'react-i18next';
import { PiUserPlus, PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostAuthCreate } from 'services/auth/createUser';
import { IAuthUserFormValues, ICreateAuthUserBody } from 'services/auth/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateUser = () => {
  const { mutateAsync } = usePostAuthCreate();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const mutateOptions = useMutateOptions<IAuthUserFormValues>();

  const handlePostUser = async (
    values: IAuthUserFormValues,
    helpers: FormikHelpers<IAuthUserFormValues>
  ) => {
    const { passwordConfirm: _passwordConfirm, ...body } = values;
    const payload: ICreateAuthUserBody = body;

    await mutateAsync(payload, {
      ...mutateOptions(helpers),
      onSuccess: () => {
        navigate('/users');
      },
    });
  };

  return (
    <Form.AuthUser
      i18nextPrefix='user'
      initialValues={authUserFormInitialValues}
      onSubmit={handlePostUser}
      tittle={t('user.title.create')}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate('/users')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiUserPlus />} />
        </Button>
      }
    />
  );
};

export default CreateUser;
